export const CampaignRoute = {
  CAMPAIGNS: 'campaigns',
};

export const CampaignPathName = {
  CAMPAIGNS: 'campaigns',
  SERVICE_CAMPAIGNS: 'service_campaigns',
};

export const CampaignServiceDisplayName = {
  TAP_ORDERS: i18n.$t('TapOrders'),
  ADFLO: i18n.$t('AdFlo'),
};

export const CampaignServiceId = {
  TAP_ORDERS: '299',
  ADFLO: '318',
};

export const MAX_CAMPAIGNS_ON_EXPORT = 10000000; // 10 Million
